import { useEffect, useState } from "react";

const weekDays = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

export default function ConsultantSchedule() {
  const consultantId = localStorage.getItem("consultant_id");

  const [schedules, setSchedules] = useState([]);
  const [form, setForm] = useState({
    day: "周一",
    start_time: "09:00",
    end_time: "10:00",
  });

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {
      const res = await fetch(
        `/api/consultant/schedule/${consultantId}`
      );
      const data = await res.json();
      setSchedules(data.schedules || []);
    } catch (err) {
      console.error(err);
    }
  };

  const addSchedule = async () => {
    if (form.start_time >= form.end_time) {
      alert("结束时间必须晚于开始时间");
      return;
    }

    try {
      const res = await fetch("/api/consultant/schedule", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          consultant_id: consultantId,
          ...form,
        }),
      });

      const data = await res.json();
      alert(data.msg || "添加成功");
      fetchSchedules();
    } catch (err) {
      console.error(err);
    }
  };

  const deleteSchedule = async (id) => {
    if (!window.confirm("确定删除这个时间段吗？")) return;

    try {
      const res = await fetch(
        `/api/consultant/schedule/${id}`,
        {
          method: "DELETE",
        }
      );

      const data = await res.json();
      alert(data.msg || "删除成功");
      fetchSchedules();
    } catch (err) {
      console.error(err);
    }
  };

  const toggleSchedule = async (id) => {
    try {
      const res = await fetch(
        `/api/consultant/schedule/${id}/toggle`,
        {
          method: "POST",
        }
      );

      const data = await res.json();
      alert(data.msg || "状态已更新");
      fetchSchedules();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8">时间管理</h1>

      <div className="bg-gray-50 rounded-2xl p-6 mb-8">
        <h2 className="text-xl font-bold mb-5">新增可预约时间</h2>

        <div className="grid md:grid-cols-4 gap-4 items-end">
          <div>
            <label className="block text-gray-500 mb-2">星期</label>
            <select
              value={form.day}
              onChange={(e) => setForm({ ...form, day: e.target.value })}
              className="w-full border rounded-xl px-4 py-3"
            >
              {weekDays.map((day) => (
                <option key={day} value={day}>
                  {day}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-gray-500 mb-2">开始时间</label>
            <input
              type="time"
              value={form.start_time}
              onChange={(e) =>
                setForm({ ...form, start_time: e.target.value })
              }
              className="w-full border rounded-xl px-4 py-3"
            />
          </div>

          <div>
            <label className="block text-gray-500 mb-2">结束时间</label>
            <input
              type="time"
              value={form.end_time}
              onChange={(e) =>
                setForm({ ...form, end_time: e.target.value })
              }
              className="w-full border rounded-xl px-4 py-3"
            />
          </div>

          <button
            onClick={addSchedule}
            className="bg-blue-500 hover:bg-blue-600 text-white rounded-xl px-6 py-3"
          >
            添加时间
          </button>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-bold mb-5">我的可预约时间</h2>

        {schedules.length === 0 ? (
          <p className="text-gray-400">暂无可预约时间</p>
        ) : (
          <div className="space-y-4">
            {schedules.map((item) => (
              <div
                key={item.id}
                className="border rounded-2xl p-5 flex justify-between items-center"
              >
                <div>
                  <p className="text-lg font-bold">
                    {item.day} {item.start_time} - {item.end_time}
                  </p>

                  <p
                    className={
                      item.is_active ? "text-green-500" : "text-gray-400"
                    }
                  >
                    {item.is_active ? "可预约" : "已关闭"}
                  </p>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => toggleSchedule(item.id)}
                    className={`px-4 py-2 rounded-xl text-white ${
                      item.is_active
                        ? "bg-yellow-500 hover:bg-yellow-600"
                        : "bg-green-500 hover:bg-green-600"
                    }`}
                  >
                    {item.is_active ? "关闭" : "开启"}
                  </button>

                  <button
                    onClick={() => deleteSchedule(item.id)}
                    className="px-4 py-2 rounded-xl bg-red-400 hover:bg-red-500 text-white"
                  >
                    删除
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
